import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { observer } from "mobx-react-lite";
import { Input } from "@frui.ts/bootstrap";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import type DeadLetterTopicsActionSearchListViewModel from "viewModels/administration/deadLetterTopics/actionSearch/deadLetterTopicsActionSearchListViewModel";
import { translateGeneral } from "utils/localizations";
import DateRangeInputControl from "controls/dateRangeInput";
import FilterView from "views/common/filter";

export interface DeadLetterTopicsActionSearchFilterProps {
  vm: DeadLetterTopicsActionSearchListViewModel;
}

const DeadLetterTopicsActionSearchFilters = observer((props: DeadLetterTopicsActionSearchFilterProps) => {
  const { vm } = props;

  return (
    <FilterView vm={vm}>
      <div className="row">
        <Form.Group as={Col} lg={8} xl={6}>
          <Form.Label>{vm.translateFilterAttribute("createdAtRange")}</Form.Label>
          <DateRangeInputControl target={vm.filter} property="createdAtRange" />
        </Form.Group>
        <Form.Group as={Col} lg={5} xl={4}>
          <Form.Label>{vm.translateFilterAttribute("createdBy")}</Form.Label>
          <Input target={vm.filter} property="createdBy" placeholder={translateGeneral("search")} />
        </Form.Group>
        <Form.Group as={Col} lg={3} xl={2}>
          <Form.Label>{vm.translateFilterAttribute("type")}</Form.Label>
          <AdvancedSelect
            target={vm.filter}
            property="type"
            items={vm.messageTypeOptions}
            allowEmpty={true}
            placeholder={translateGeneral("select")}
          />
        </Form.Group>
      </div>
    </FilterView>
  );
});

export default DeadLetterTopicsActionSearchFilters;
